export default __webpack_public_path__ + "static/media/zip.9305dad0.svg";